import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";

import logo1 from "../../../bgimage/LGTAdmin.png";
import logo2 from "../../../bgimage/FAVI ICON (1).png";
import { PiDotsNineBold } from "react-icons/pi";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);
  return (
    <div className="nav-header">
      <Link
        to="/dashboard"
        className="brand-logo d-flex align-items-center justify-content-center gap-2"
      >
        {/* Mobile logo */}
        <img
          src={logo1}
          className="logo-color d-md-none"
          alt=""
          height={60}
          width={60}
        />

        {/* Desktop */}
        <div className="d-none d-md-flex align-items-center gap-2">
          <img src={logo1} alt="" height={60} />
          {/* <p className="mb-0 text-dark">Let’s Grow Together</p> */}
        </div>
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          //openMenuToggle();
          NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <div className="">
            {" "}
            <i className="fa fa-arrow-left-long fs-3 text_green lines"></i>
          </div>
          {/* <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span> */}
          <PiDotsNineBold style={{ fontSize: "2.5rem" }} />
        </div>
      </div>
    </div>
  );
};

export default NavHader;
